module.exports = __webpack_public_path__ + "images/home/product/features-calendar-02f73ad3ce889e7ad9b0817522dd2601.png";